import styles from "../list.module.css";
import { ArrowLeft } from "react-feather";
import DriverCard from "./DriverCard";

const Step3 = ({ routes, setCurrentStep, setLoading, setSnackbarType, setSnackbarOpen, setSnackbarMessage, setRoutes }) => {

    return (<div className={`${styles.MainDiv}`}>
        <div>
            <div className={`${styles.DriverNextPreBuSec}`}>
                <button onClick={(e) => setCurrentStep(2)}>
                    <ArrowLeft /> &nbsp; Back
                </button>
            </div>
            {routes?.map((item) => {
                return (<DriverCard item={item} routes={routes} setLoading={setLoading.bind(this)} setSnackbarType={setSnackbarType.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} setSnackbarMessage={setSnackbarMessage.bind(this)} setRoutes={setRoutes.bind(this)} />);
            })}
        </div>
    </div>);
};

export default Step3;